import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ConfigurationService } from '../../configuration.service';
import { DashboardConfig } from '../../dashboard-config.model';

@Component({
  selector: 'app-search-dashboard-config',
  templateUrl: './search-dashboard-config.component.html',
  styleUrls: ['./search-dashboard-config.component.scss']
})
export class SearchDashboardConfigComponent implements OnInit {

  dataSource = new MatTableDataSource<DashboardConfig>();
  selection = new SelectionModel<any>(true, []);
  displayedColumns: string[] = ['sequence', 'firstName', 'ageDesc', 'categoryName', 'party', 'userhe', 'userar', 'useropt', 'userdct', 'userphy',
    'userproc', 'usercons', 'doctor', 'optName', 'proN', 'oldmrdno', 'contactNo', 'waitingReason', 'companyName', 'sap', 'remarks', 'adharCard',
    'ispd', 'totalTime', 'pHy', 'isActive', 'returnWidth', 'branchName' ];

  constructor(public dialog: MatDialog, public configurationService:ConfigurationService) { }

  ngOnInit(): void {
    this.getdashboardList();
    this.configurationService.selectedDashboardData = null;
  }


  getdashboardList(){
    let type =0;
    this.configurationService.getDashboardConfig(type).subscribe(data =>{
      this.dataSource.data = data;
      if(data.length ==0){
        let type1=-1;
        this.configurationService.getDashboardConfig(type1).subscribe(data =>{
          this.dataSource.data = data;
        
        });
      }
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  selectRow(row) {
    this.selection.toggle(row);
    this.configurationService.selectedDashboardData = row;
    this.dialog.closeAll();
  }

  closedialog() {
    this.dialog.closeAll();
  }

}
